import { LIMIT } from "../constent/ConstentVariable";
import { useState } from "react";
import { useEffect } from "react";
import { GET_NOTES_TEMPLATES_DATA, UPDATE_NOTES } from "../actions/notesAct";
import { fetchMutation, fetchQuery } from "../../../actions";
import { ShowAlert } from "../../../common/alert";
import { errorToDisplay } from "../../../helper/CommonFuncs";
import SelectTemplateLoader from "./SelectTemplateLoader";
import NotesCheckBox from "./NoteCheckBox";

const ViewNotesTemplates = () => {
   const [templatesContent, setTemplatesContent] = useState({
      list: [],
      loading: true,
      notesTemplate: { limit: LIMIT, offset: 0, enabledTemplate: false },
   });
   const getNotesTemplate = () => {
      setTemplatesContent({ ...templatesContent, loading: true });
      let obj = {};
      let notesTemplate = {
         limit: 50,
         offset: 0,
      };
      obj.notesTemplate = notesTemplate;
      fetchQuery(
         GET_NOTES_TEMPLATES_DATA,
         obj,
         (res) => {
            const contentData = res?.data?.getNotesTemplate?.template || [];
            const totalResults = contentData;
            setTemplatesContent({
               ...templatesContent,
               list: totalResults,
               loading: false,
               offset: null,
            });
         },
         (err) => {
            ShowAlert(errorToDisplay(err), "error");
            setTemplatesContent({ ...templatesContent, loading: false });
         }
      );
   };
   const UpdateNotes = (id, isDisabled, onError = () => {}) => {
      let notesObj = {};
      notesObj = {
         notesTemplate: {
            id: id,
            isDisable: isDisabled,
         },
      };
      fetchMutation(
         UPDATE_NOTES,
         notesObj,
         (res) => {},
         (error) => {
            ShowAlert(errorToDisplay(error), "error");
            onError();
         }
      );
   };
   useEffect(() => {
      getNotesTemplate();
   }, []);

   return (
      <>
         {templatesContent.loading ? (
            <div className="px-5 select-temp-width no-scrollbar ">
               <SelectTemplateLoader count={7} fullWidth="94%" sklettenMargen="4" sklettenPading="4.5" />
            </div>
         ) : (
            <div className="select-temp-width  scrollbar-notes epic-temp-select-padding ">
               {templatesContent?.list?.map((item, index) => {
                  const tempId = item?.id;
                  const isDisable = item?.isDisable;
                  const isLast = index === templatesContent.list.length - 1;
                  return (
                     <>
                        <div key={item?.id} className={`d-flex aline-center template-flex-container`}>
                           <div className="temp-title-text text-truncate-custom">{item?.title || "Clinical note"}</div>
                           <div className="toggle-flex-container">
                              <NotesCheckBox
                                 width="51px"
                                 height="30px"
                                 tempId={tempId}
                                 isDisable={isDisable}
                                 UpdateNotes={UpdateNotes}
                              />
                           </div>
                        </div>
                        {!isLast && <div className="border-bottom border "></div>}
                     </>
                  );
               })}
            </div>
         )}
      </>
   );
};

export default ViewNotesTemplates;
